import io from 'socket.io-client'
import { debounce } from 'lodash'

const logEvent = (message, data) => {
    if (window.location.href.includes('debug')) {
        console.log(message, data)
    }
}

const BATCH_SIZE = 10
const DEBOUNCE_WAIT = 200
const MAX_WAIT = 2000

let socket = null

// queues (global like your mixin instance state)
let baseQueue = Object.create(null)
let sharingQueue = Object.create(null)

let storeRef = null

let flushQueuesDebounced = null

function flushQueues() {
    if (!storeRef?.state?.tracker?.shouldUpdateTrackers) return

    const baseItems = Object.values(baseQueue)
    const sharingItems = Object.values(sharingQueue)

    baseQueue = Object.create(null)
    sharingQueue = Object.create(null)

    if (baseItems.length) {
        logEvent('Updating items', baseItems)
        storeRef.dispatch('tracker/batchUpdateTrackerLive', baseItems)
    }

    if (sharingItems.length) {
        logEvent('Updating shared items', sharingItems)
        storeRef.dispatch('sharing/batchUpdateSharedTrackerLive', sharingItems)
    }
}

function ensureDebounce() {
    if (!flushQueuesDebounced) {
        flushQueuesDebounced = debounce(flushQueues, DEBOUNCE_WAIT, {
            maxWait: MAX_WAIT,
        })
    }
}

function enqueue(type, data) {
    logEvent('Received asset update', data)

    const queue = type === 'base' ? baseQueue : sharingQueue
    queue[data.tracker] = data

    if (
        storeRef?.state?.tracker?.shouldUpdateTrackers &&
        Object.values(queue).length > BATCH_SIZE
    ) {
        flushQueuesDebounced?.cancel()
        flushQueues()
        return
    }

    flushQueuesDebounced()
}

function setupListeners() {
    if (!socket) return

    socket.on('asset_update', data => {
        if (storeRef?.state?.sharing?.sharingConfig) {
            enqueue('sharing', data) // live-update for share tokens
        } else {
            enqueue('base', data) // live-update for regular login
        }
    })

    socket.on('debug', data => {
        if (window.location.href.includes('debug')) {
            console.log('Socket debug:', data)
        }

        if (data === 'Invalid token') {
            storeRef?.dispatch('auth/refreshTokenIfNecessary')
        }
    })
}

export function connect(url, store) {
    storeRef = store

    if (socket) {
        socket.disconnect()
    }

    socket = io(url, {
        transports: ['websocket'],
    })

    ensureDebounce()
    setupListeners()

    return socket
}

export function disconnect() {
    socket?.disconnect()
    socket = null

    baseQueue = Object.create(null)
    sharingQueue = Object.create(null)

    flushQueuesDebounced?.cancel()
    flushQueuesDebounced = null
}

export function authenticate(token) {
    socket?.emit('authenticate', { token })
}

// used by plugin if needed
export function getSocket() {
    return socket
}
